export default {
	tour: {
		footer: {
			skip: 'Tour überspringen',
			back: 'Zurück',
			next: 'Weiter',
			done: 'Fertig',
			wait: 'Bitte warten…',
		},
	},
}
